import { app } from '@/bootloader';
import { mixin } from '@/mixin';
import { csvMixinService } from '@/services/csv';

app.mixin(mixin);
app.mixin(csvMixinService);
